export default "__VITE_ASSET__f0419fed__"